/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ImpressumRouteImport } from './routes/impressum'
import { Route as DatenschutzRouteImport } from './routes/datenschutz'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SignTokenRouteImport } from './routes/sign.$token'
import { Route as ListingTokenRouteImport } from './routes/listing.$token'
import { Route as AppVoiceCallsRouteImport } from './routes/_app/voice-calls'
import { Route as AppViewingConfirmationsRouteImport } from './routes/_app/viewing-confirmations'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppRechercheRouteImport } from './routes/_app/recherche'
import { Route as AppRadarRouteImport } from './routes/_app/radar'
import { Route as AppPropertiesRouteImport } from './routes/_app/properties'
import { Route as AppOffersRouteImport } from './routes/_app/offers'
import { Route as AppMediathekRouteImport } from './routes/_app/mediathek'
import { Route as AppMarketingUebersichtRouteImport } from './routes/_app/marketing-uebersicht'
import { Route as AppMarketingAdminRouteImport } from './routes/_app/marketing-admin'
import { Route as AppMarketingRouteImport } from './routes/_app/marketing'
import { Route as AppKalenderRouteImport } from './routes/_app/kalender'
import { Route as AppInteressentenRouteImport } from './routes/_app/interessenten'
import { Route as AppHelpRouteImport } from './routes/_app/help'
import { Route as AppEmailMarketingRouteImport } from './routes/_app/email-marketing'
import { Route as AppDokumenteRouteImport } from './routes/_app/dokumente'
import { Route as AppDesignRouteImport } from './routes/_app/design'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppCommunicationRouteImport } from './routes/_app/communication'
import { Route as AppClientsRouteImport } from './routes/_app/clients'
import { Route as AppBlogRouteImport } from './routes/_app/blog'
import { Route as AppAppointmentsRouteImport } from './routes/_app/appointments'
import { Route as AppAnalyticsRouteImport } from './routes/_app/analytics'
import { Route as AppPropertiesLeadsRouteImport } from './routes/_app/properties.leads'
import { Route as AppPropertiesActiveRouteImport } from './routes/_app/properties.active'
import { Route as AppOffersIdRouteImport } from './routes/_app/offers_.$id'
import { Route as AppDokumenteKycRouteImport } from './routes/_app/dokumente_.kyc'
import { Route as AppDokumenteChecklisteRouteImport } from './routes/_app/dokumente_.checkliste'
import { Route as AppAppointmentsViewingRouteImport } from './routes/_app/appointments.viewing'
import { Route as AppAppointmentsAcquisitionRouteImport } from './routes/_app/appointments.acquisition'
import { Route as AppAdminZinshaeuserRouteImport } from './routes/_app/admin.zinshaeuser'
import { Route as AppAdminTransfersRouteImport } from './routes/_app/admin.transfers'
import { Route as AppAdminStaffReportRouteImport } from './routes/_app/admin.staff-report'
import { Route as AppAdminSellerActivityRouteImport } from './routes/_app/admin.seller-activity'
import { Route as AppAdminSecurityRouteImport } from './routes/_app/admin.security'
import { Route as AppAdminJustimmoRouteImport } from './routes/_app/admin.justimmo'
import { Route as AppAdminAuditLogRouteImport } from './routes/_app/admin.audit-log'
import { Route as AppAdminAppointmentsOrphansRouteImport } from './routes/_app/admin.appointments-orphans'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ImpressumRoute = ImpressumRouteImport.update({
  id: '/impressum',
  path: '/impressum',
  getParentRoute: () => rootRouteImport,
} as any)
const DatenschutzRoute = DatenschutzRouteImport.update({
  id: '/datenschutz',
  path: '/datenschutz',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SignTokenRoute = SignTokenRouteImport.update({
  id: '/sign/$token',
  path: '/sign/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const ListingTokenRoute = ListingTokenRouteImport.update({
  id: '/listing/$token',
  path: '/listing/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppVoiceCallsRoute = AppVoiceCallsRouteImport.update({
  id: '/voice-calls',
  path: '/voice-calls',
  getParentRoute: () => AppRoute,
} as any)
const AppViewingConfirmationsRoute = AppViewingConfirmationsRouteImport.update({
  id: '/viewing-confirmations',
  path: '/viewing-confirmations',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppRechercheRoute = AppRechercheRouteImport.update({
  id: '/recherche',
  path: '/recherche',
  getParentRoute: () => AppRoute,
} as any)
const AppRadarRoute = AppRadarRouteImport.update({
  id: '/radar',
  path: '/radar',
  getParentRoute: () => AppRoute,
} as any)
const AppPropertiesRoute = AppPropertiesRouteImport.update({
  id: '/properties',
  path: '/properties',
  getParentRoute: () => AppRoute,
} as any)
const AppOffersRoute = AppOffersRouteImport.update({
  id: '/offers',
  path: '/offers',
  getParentRoute: () => AppRoute,
} as any)
const AppMediathekRoute = AppMediathekRouteImport.update({
  id: '/mediathek',
  path: '/mediathek',
  getParentRoute: () => AppRoute,
} as any)
const AppMarketingUebersichtRoute = AppMarketingUebersichtRouteImport.update({
  id: '/marketing-uebersicht',
  path: '/marketing-uebersicht',
  getParentRoute: () => AppRoute,
} as any)
const AppMarketingAdminRoute = AppMarketingAdminRouteImport.update({
  id: '/marketing-admin',
  path: '/marketing-admin',
  getParentRoute: () => AppRoute,
} as any)
const AppMarketingRoute = AppMarketingRouteImport.update({
  id: '/marketing',
  path: '/marketing',
  getParentRoute: () => AppRoute,
} as any)
const AppKalenderRoute = AppKalenderRouteImport.update({
  id: '/kalender',
  path: '/kalender',
  getParentRoute: () => AppRoute,
} as any)
const AppInteressentenRoute = AppInteressentenRouteImport.update({
  id: '/interessenten',
  path: '/interessenten',
  getParentRoute: () => AppRoute,
} as any)
const AppHelpRoute = AppHelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => AppRoute,
} as any)
const AppEmailMarketingRoute = AppEmailMarketingRouteImport.update({
  id: '/email-marketing',
  path: '/email-marketing',
  getParentRoute: () => AppRoute,
} as any)
const AppDokumenteRoute = AppDokumenteRouteImport.update({
  id: '/dokumente',
  path: '/dokumente',
  getParentRoute: () => AppRoute,
} as any)
const AppDesignRoute = AppDesignRouteImport.update({
  id: '/design',
  path: '/design',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppCommunicationRoute = AppCommunicationRouteImport.update({
  id: '/communication',
  path: '/communication',
  getParentRoute: () => AppRoute,
} as any)
const AppClientsRoute = AppClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => AppRoute,
} as any)
const AppBlogRoute = AppBlogRouteImport.update({
  id: '/blog',
  path: '/blog',
  getParentRoute: () => AppRoute,
} as any)
const AppAppointmentsRoute = AppAppointmentsRouteImport.update({
  id: '/appointments',
  path: '/appointments',
  getParentRoute: () => AppRoute,
} as any)
const AppAnalyticsRoute = AppAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AppRoute,
} as any)
const AppPropertiesLeadsRoute = AppPropertiesLeadsRouteImport.update({
  id: '/leads',
  path: '/leads',
  getParentRoute: () => AppPropertiesRoute,
} as any)
const AppPropertiesActiveRoute = AppPropertiesActiveRouteImport.update({
  id: '/active',
  path: '/active',
  getParentRoute: () => AppPropertiesRoute,
} as any)
const AppOffersIdRoute = AppOffersIdRouteImport.update({
  id: '/offers_/$id',
  path: '/offers/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppDokumenteKycRoute = AppDokumenteKycRouteImport.update({
  id: '/dokumente_/kyc',
  path: '/dokumente/kyc',
  getParentRoute: () => AppRoute,
} as any)
const AppDokumenteChecklisteRoute = AppDokumenteChecklisteRouteImport.update({
  id: '/dokumente_/checkliste',
  path: '/dokumente/checkliste',
  getParentRoute: () => AppRoute,
} as any)
const AppAppointmentsViewingRoute = AppAppointmentsViewingRouteImport.update({
  id: '/viewing',
  path: '/viewing',
  getParentRoute: () => AppAppointmentsRoute,
} as any)
const AppAppointmentsAcquisitionRoute =
  AppAppointmentsAcquisitionRouteImport.update({
    id: '/acquisition',
    path: '/acquisition',
    getParentRoute: () => AppAppointmentsRoute,
  } as any)
const AppAdminZinshaeuserRoute = AppAdminZinshaeuserRouteImport.update({
  id: '/admin/zinshaeuser',
  path: '/admin/zinshaeuser',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminTransfersRoute = AppAdminTransfersRouteImport.update({
  id: '/admin/transfers',
  path: '/admin/transfers',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminStaffReportRoute = AppAdminStaffReportRouteImport.update({
  id: '/admin/staff-report',
  path: '/admin/staff-report',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminSellerActivityRoute = AppAdminSellerActivityRouteImport.update({
  id: '/admin/seller-activity',
  path: '/admin/seller-activity',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminSecurityRoute = AppAdminSecurityRouteImport.update({
  id: '/admin/security',
  path: '/admin/security',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminJustimmoRoute = AppAdminJustimmoRouteImport.update({
  id: '/admin/justimmo',
  path: '/admin/justimmo',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminAuditLogRoute = AppAdminAuditLogRouteImport.update({
  id: '/admin/audit-log',
  path: '/admin/audit-log',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminAppointmentsOrphansRoute =
  AppAdminAppointmentsOrphansRouteImport.update({
    id: '/admin/appointments-orphans',
    path: '/admin/appointments-orphans',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/datenschutz': typeof DatenschutzRoute
  '/impressum': typeof ImpressumRoute
  '/login': typeof LoginRoute
  '/verify-email': typeof VerifyEmailRoute
  '/analytics': typeof AppAnalyticsRoute
  '/appointments': typeof AppAppointmentsRouteWithChildren
  '/blog': typeof AppBlogRoute
  '/clients': typeof AppClientsRoute
  '/communication': typeof AppCommunicationRoute
  '/dashboard': typeof AppDashboardRoute
  '/design': typeof AppDesignRoute
  '/dokumente': typeof AppDokumenteRoute
  '/email-marketing': typeof AppEmailMarketingRoute
  '/help': typeof AppHelpRoute
  '/interessenten': typeof AppInteressentenRoute
  '/kalender': typeof AppKalenderRoute
  '/marketing': typeof AppMarketingRoute
  '/marketing-admin': typeof AppMarketingAdminRoute
  '/marketing-uebersicht': typeof AppMarketingUebersichtRoute
  '/mediathek': typeof AppMediathekRoute
  '/offers': typeof AppOffersRoute
  '/properties': typeof AppPropertiesRouteWithChildren
  '/radar': typeof AppRadarRoute
  '/recherche': typeof AppRechercheRoute
  '/settings': typeof AppSettingsRoute
  '/viewing-confirmations': typeof AppViewingConfirmationsRoute
  '/voice-calls': typeof AppVoiceCallsRoute
  '/listing/$token': typeof ListingTokenRoute
  '/sign/$token': typeof SignTokenRoute
  '/admin/appointments-orphans': typeof AppAdminAppointmentsOrphansRoute
  '/admin/audit-log': typeof AppAdminAuditLogRoute
  '/admin/justimmo': typeof AppAdminJustimmoRoute
  '/admin/security': typeof AppAdminSecurityRoute
  '/admin/seller-activity': typeof AppAdminSellerActivityRoute
  '/admin/staff-report': typeof AppAdminStaffReportRoute
  '/admin/transfers': typeof AppAdminTransfersRoute
  '/admin/zinshaeuser': typeof AppAdminZinshaeuserRoute
  '/appointments/acquisition': typeof AppAppointmentsAcquisitionRoute
  '/appointments/viewing': typeof AppAppointmentsViewingRoute
  '/dokumente/checkliste': typeof AppDokumenteChecklisteRoute
  '/dokumente/kyc': typeof AppDokumenteKycRoute
  '/offers/$id': typeof AppOffersIdRoute
  '/properties/active': typeof AppPropertiesActiveRoute
  '/properties/leads': typeof AppPropertiesLeadsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/datenschutz': typeof DatenschutzRoute
  '/impressum': typeof ImpressumRoute
  '/login': typeof LoginRoute
  '/verify-email': typeof VerifyEmailRoute
  '/analytics': typeof AppAnalyticsRoute
  '/appointments': typeof AppAppointmentsRouteWithChildren
  '/blog': typeof AppBlogRoute
  '/clients': typeof AppClientsRoute
  '/communication': typeof AppCommunicationRoute
  '/dashboard': typeof AppDashboardRoute
  '/design': typeof AppDesignRoute
  '/dokumente': typeof AppDokumenteRoute
  '/email-marketing': typeof AppEmailMarketingRoute
  '/help': typeof AppHelpRoute
  '/interessenten': typeof AppInteressentenRoute
  '/kalender': typeof AppKalenderRoute
  '/marketing': typeof AppMarketingRoute
  '/marketing-admin': typeof AppMarketingAdminRoute
  '/marketing-uebersicht': typeof AppMarketingUebersichtRoute
  '/mediathek': typeof AppMediathekRoute
  '/offers': typeof AppOffersRoute
  '/properties': typeof AppPropertiesRouteWithChildren
  '/radar': typeof AppRadarRoute
  '/recherche': typeof AppRechercheRoute
  '/settings': typeof AppSettingsRoute
  '/viewing-confirmations': typeof AppViewingConfirmationsRoute
  '/voice-calls': typeof AppVoiceCallsRoute
  '/listing/$token': typeof ListingTokenRoute
  '/sign/$token': typeof SignTokenRoute
  '/admin/appointments-orphans': typeof AppAdminAppointmentsOrphansRoute
  '/admin/audit-log': typeof AppAdminAuditLogRoute
  '/admin/justimmo': typeof AppAdminJustimmoRoute
  '/admin/security': typeof AppAdminSecurityRoute
  '/admin/seller-activity': typeof AppAdminSellerActivityRoute
  '/admin/staff-report': typeof AppAdminStaffReportRoute
  '/admin/transfers': typeof AppAdminTransfersRoute
  '/admin/zinshaeuser': typeof AppAdminZinshaeuserRoute
  '/appointments/acquisition': typeof AppAppointmentsAcquisitionRoute
  '/appointments/viewing': typeof AppAppointmentsViewingRoute
  '/dokumente/checkliste': typeof AppDokumenteChecklisteRoute
  '/dokumente/kyc': typeof AppDokumenteKycRoute
  '/offers/$id': typeof AppOffersIdRoute
  '/properties/active': typeof AppPropertiesActiveRoute
  '/properties/leads': typeof AppPropertiesLeadsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/datenschutz': typeof DatenschutzRoute
  '/impressum': typeof ImpressumRoute
  '/login': typeof LoginRoute
  '/verify-email': typeof VerifyEmailRoute
  '/_app/analytics': typeof AppAnalyticsRoute
  '/_app/appointments': typeof AppAppointmentsRouteWithChildren
  '/_app/blog': typeof AppBlogRoute
  '/_app/clients': typeof AppClientsRoute
  '/_app/communication': typeof AppCommunicationRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/design': typeof AppDesignRoute
  '/_app/dokumente': typeof AppDokumenteRoute
  '/_app/email-marketing': typeof AppEmailMarketingRoute
  '/_app/help': typeof AppHelpRoute
  '/_app/interessenten': typeof AppInteressentenRoute
  '/_app/kalender': typeof AppKalenderRoute
  '/_app/marketing': typeof AppMarketingRoute
  '/_app/marketing-admin': typeof AppMarketingAdminRoute
  '/_app/marketing-uebersicht': typeof AppMarketingUebersichtRoute
  '/_app/mediathek': typeof AppMediathekRoute
  '/_app/offers': typeof AppOffersRoute
  '/_app/properties': typeof AppPropertiesRouteWithChildren
  '/_app/radar': typeof AppRadarRoute
  '/_app/recherche': typeof AppRechercheRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/viewing-confirmations': typeof AppViewingConfirmationsRoute
  '/_app/voice-calls': typeof AppVoiceCallsRoute
  '/listing/$token': typeof ListingTokenRoute
  '/sign/$token': typeof SignTokenRoute
  '/_app/admin/appointments-orphans': typeof AppAdminAppointmentsOrphansRoute
  '/_app/admin/audit-log': typeof AppAdminAuditLogRoute
  '/_app/admin/justimmo': typeof AppAdminJustimmoRoute
  '/_app/admin/security': typeof AppAdminSecurityRoute
  '/_app/admin/seller-activity': typeof AppAdminSellerActivityRoute
  '/_app/admin/staff-report': typeof AppAdminStaffReportRoute
  '/_app/admin/transfers': typeof AppAdminTransfersRoute
  '/_app/admin/zinshaeuser': typeof AppAdminZinshaeuserRoute
  '/_app/appointments/acquisition': typeof AppAppointmentsAcquisitionRoute
  '/_app/appointments/viewing': typeof AppAppointmentsViewingRoute
  '/_app/dokumente_/checkliste': typeof AppDokumenteChecklisteRoute
  '/_app/dokumente_/kyc': typeof AppDokumenteKycRoute
  '/_app/offers_/$id': typeof AppOffersIdRoute
  '/_app/properties/active': typeof AppPropertiesActiveRoute
  '/_app/properties/leads': typeof AppPropertiesLeadsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/datenschutz'
    | '/impressum'
    | '/login'
    | '/verify-email'
    | '/analytics'
    | '/appointments'
    | '/blog'
    | '/clients'
    | '/communication'
    | '/dashboard'
    | '/design'
    | '/dokumente'
    | '/email-marketing'
    | '/help'
    | '/interessenten'
    | '/kalender'
    | '/marketing'
    | '/marketing-admin'
    | '/marketing-uebersicht'
    | '/mediathek'
    | '/offers'
    | '/properties'
    | '/radar'
    | '/recherche'
    | '/settings'
    | '/viewing-confirmations'
    | '/voice-calls'
    | '/listing/$token'
    | '/sign/$token'
    | '/admin/appointments-orphans'
    | '/admin/audit-log'
    | '/admin/justimmo'
    | '/admin/security'
    | '/admin/seller-activity'
    | '/admin/staff-report'
    | '/admin/transfers'
    | '/admin/zinshaeuser'
    | '/appointments/acquisition'
    | '/appointments/viewing'
    | '/dokumente/checkliste'
    | '/dokumente/kyc'
    | '/offers/$id'
    | '/properties/active'
    | '/properties/leads'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/datenschutz'
    | '/impressum'
    | '/login'
    | '/verify-email'
    | '/analytics'
    | '/appointments'
    | '/blog'
    | '/clients'
    | '/communication'
    | '/dashboard'
    | '/design'
    | '/dokumente'
    | '/email-marketing'
    | '/help'
    | '/interessenten'
    | '/kalender'
    | '/marketing'
    | '/marketing-admin'
    | '/marketing-uebersicht'
    | '/mediathek'
    | '/offers'
    | '/properties'
    | '/radar'
    | '/recherche'
    | '/settings'
    | '/viewing-confirmations'
    | '/voice-calls'
    | '/listing/$token'
    | '/sign/$token'
    | '/admin/appointments-orphans'
    | '/admin/audit-log'
    | '/admin/justimmo'
    | '/admin/security'
    | '/admin/seller-activity'
    | '/admin/staff-report'
    | '/admin/transfers'
    | '/admin/zinshaeuser'
    | '/appointments/acquisition'
    | '/appointments/viewing'
    | '/dokumente/checkliste'
    | '/dokumente/kyc'
    | '/offers/$id'
    | '/properties/active'
    | '/properties/leads'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/datenschutz'
    | '/impressum'
    | '/login'
    | '/verify-email'
    | '/_app/analytics'
    | '/_app/appointments'
    | '/_app/blog'
    | '/_app/clients'
    | '/_app/communication'
    | '/_app/dashboard'
    | '/_app/design'
    | '/_app/dokumente'
    | '/_app/email-marketing'
    | '/_app/help'
    | '/_app/interessenten'
    | '/_app/kalender'
    | '/_app/marketing'
    | '/_app/marketing-admin'
    | '/_app/marketing-uebersicht'
    | '/_app/mediathek'
    | '/_app/offers'
    | '/_app/properties'
    | '/_app/radar'
    | '/_app/recherche'
    | '/_app/settings'
    | '/_app/viewing-confirmations'
    | '/_app/voice-calls'
    | '/listing/$token'
    | '/sign/$token'
    | '/_app/admin/appointments-orphans'
    | '/_app/admin/audit-log'
    | '/_app/admin/justimmo'
    | '/_app/admin/security'
    | '/_app/admin/seller-activity'
    | '/_app/admin/staff-report'
    | '/_app/admin/transfers'
    | '/_app/admin/zinshaeuser'
    | '/_app/appointments/acquisition'
    | '/_app/appointments/viewing'
    | '/_app/dokumente_/checkliste'
    | '/_app/dokumente_/kyc'
    | '/_app/offers_/$id'
    | '/_app/properties/active'
    | '/_app/properties/leads'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  DatenschutzRoute: typeof DatenschutzRoute
  ImpressumRoute: typeof ImpressumRoute
  LoginRoute: typeof LoginRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  ListingTokenRoute: typeof ListingTokenRoute
  SignTokenRoute: typeof SignTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/impressum': {
      id: '/impressum'
      path: '/impressum'
      fullPath: '/impressum'
      preLoaderRoute: typeof ImpressumRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/datenschutz': {
      id: '/datenschutz'
      path: '/datenschutz'
      fullPath: '/datenschutz'
      preLoaderRoute: typeof DatenschutzRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign/$token': {
      id: '/sign/$token'
      path: '/sign/$token'
      fullPath: '/sign/$token'
      preLoaderRoute: typeof SignTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/listing/$token': {
      id: '/listing/$token'
      path: '/listing/$token'
      fullPath: '/listing/$token'
      preLoaderRoute: typeof ListingTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/voice-calls': {
      id: '/_app/voice-calls'
      path: '/voice-calls'
      fullPath: '/voice-calls'
      preLoaderRoute: typeof AppVoiceCallsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/viewing-confirmations': {
      id: '/_app/viewing-confirmations'
      path: '/viewing-confirmations'
      fullPath: '/viewing-confirmations'
      preLoaderRoute: typeof AppViewingConfirmationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/recherche': {
      id: '/_app/recherche'
      path: '/recherche'
      fullPath: '/recherche'
      preLoaderRoute: typeof AppRechercheRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/radar': {
      id: '/_app/radar'
      path: '/radar'
      fullPath: '/radar'
      preLoaderRoute: typeof AppRadarRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/properties': {
      id: '/_app/properties'
      path: '/properties'
      fullPath: '/properties'
      preLoaderRoute: typeof AppPropertiesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/offers': {
      id: '/_app/offers'
      path: '/offers'
      fullPath: '/offers'
      preLoaderRoute: typeof AppOffersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/mediathek': {
      id: '/_app/mediathek'
      path: '/mediathek'
      fullPath: '/mediathek'
      preLoaderRoute: typeof AppMediathekRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketing-uebersicht': {
      id: '/_app/marketing-uebersicht'
      path: '/marketing-uebersicht'
      fullPath: '/marketing-uebersicht'
      preLoaderRoute: typeof AppMarketingUebersichtRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketing-admin': {
      id: '/_app/marketing-admin'
      path: '/marketing-admin'
      fullPath: '/marketing-admin'
      preLoaderRoute: typeof AppMarketingAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/marketing': {
      id: '/_app/marketing'
      path: '/marketing'
      fullPath: '/marketing'
      preLoaderRoute: typeof AppMarketingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/kalender': {
      id: '/_app/kalender'
      path: '/kalender'
      fullPath: '/kalender'
      preLoaderRoute: typeof AppKalenderRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/interessenten': {
      id: '/_app/interessenten'
      path: '/interessenten'
      fullPath: '/interessenten'
      preLoaderRoute: typeof AppInteressentenRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/help': {
      id: '/_app/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof AppHelpRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/email-marketing': {
      id: '/_app/email-marketing'
      path: '/email-marketing'
      fullPath: '/email-marketing'
      preLoaderRoute: typeof AppEmailMarketingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dokumente': {
      id: '/_app/dokumente'
      path: '/dokumente'
      fullPath: '/dokumente'
      preLoaderRoute: typeof AppDokumenteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/design': {
      id: '/_app/design'
      path: '/design'
      fullPath: '/design'
      preLoaderRoute: typeof AppDesignRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/communication': {
      id: '/_app/communication'
      path: '/communication'
      fullPath: '/communication'
      preLoaderRoute: typeof AppCommunicationRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clients': {
      id: '/_app/clients'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof AppClientsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/blog': {
      id: '/_app/blog'
      path: '/blog'
      fullPath: '/blog'
      preLoaderRoute: typeof AppBlogRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/appointments': {
      id: '/_app/appointments'
      path: '/appointments'
      fullPath: '/appointments'
      preLoaderRoute: typeof AppAppointmentsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/analytics': {
      id: '/_app/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AppAnalyticsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/properties/leads': {
      id: '/_app/properties/leads'
      path: '/leads'
      fullPath: '/properties/leads'
      preLoaderRoute: typeof AppPropertiesLeadsRouteImport
      parentRoute: typeof AppPropertiesRoute
    }
    '/_app/properties/active': {
      id: '/_app/properties/active'
      path: '/active'
      fullPath: '/properties/active'
      preLoaderRoute: typeof AppPropertiesActiveRouteImport
      parentRoute: typeof AppPropertiesRoute
    }
    '/_app/offers_/$id': {
      id: '/_app/offers_/$id'
      path: '/offers/$id'
      fullPath: '/offers/$id'
      preLoaderRoute: typeof AppOffersIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dokumente_/kyc': {
      id: '/_app/dokumente_/kyc'
      path: '/dokumente/kyc'
      fullPath: '/dokumente/kyc'
      preLoaderRoute: typeof AppDokumenteKycRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dokumente_/checkliste': {
      id: '/_app/dokumente_/checkliste'
      path: '/dokumente/checkliste'
      fullPath: '/dokumente/checkliste'
      preLoaderRoute: typeof AppDokumenteChecklisteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/appointments/viewing': {
      id: '/_app/appointments/viewing'
      path: '/viewing'
      fullPath: '/appointments/viewing'
      preLoaderRoute: typeof AppAppointmentsViewingRouteImport
      parentRoute: typeof AppAppointmentsRoute
    }
    '/_app/appointments/acquisition': {
      id: '/_app/appointments/acquisition'
      path: '/acquisition'
      fullPath: '/appointments/acquisition'
      preLoaderRoute: typeof AppAppointmentsAcquisitionRouteImport
      parentRoute: typeof AppAppointmentsRoute
    }
    '/_app/admin/zinshaeuser': {
      id: '/_app/admin/zinshaeuser'
      path: '/admin/zinshaeuser'
      fullPath: '/admin/zinshaeuser'
      preLoaderRoute: typeof AppAdminZinshaeuserRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/transfers': {
      id: '/_app/admin/transfers'
      path: '/admin/transfers'
      fullPath: '/admin/transfers'
      preLoaderRoute: typeof AppAdminTransfersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/staff-report': {
      id: '/_app/admin/staff-report'
      path: '/admin/staff-report'
      fullPath: '/admin/staff-report'
      preLoaderRoute: typeof AppAdminStaffReportRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/seller-activity': {
      id: '/_app/admin/seller-activity'
      path: '/admin/seller-activity'
      fullPath: '/admin/seller-activity'
      preLoaderRoute: typeof AppAdminSellerActivityRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/security': {
      id: '/_app/admin/security'
      path: '/admin/security'
      fullPath: '/admin/security'
      preLoaderRoute: typeof AppAdminSecurityRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/justimmo': {
      id: '/_app/admin/justimmo'
      path: '/admin/justimmo'
      fullPath: '/admin/justimmo'
      preLoaderRoute: typeof AppAdminJustimmoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/audit-log': {
      id: '/_app/admin/audit-log'
      path: '/admin/audit-log'
      fullPath: '/admin/audit-log'
      preLoaderRoute: typeof AppAdminAuditLogRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/appointments-orphans': {
      id: '/_app/admin/appointments-orphans'
      path: '/admin/appointments-orphans'
      fullPath: '/admin/appointments-orphans'
      preLoaderRoute: typeof AppAdminAppointmentsOrphansRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppAppointmentsRouteChildren {
  AppAppointmentsAcquisitionRoute: typeof AppAppointmentsAcquisitionRoute
  AppAppointmentsViewingRoute: typeof AppAppointmentsViewingRoute
}

const AppAppointmentsRouteChildren: AppAppointmentsRouteChildren = {
  AppAppointmentsAcquisitionRoute: AppAppointmentsAcquisitionRoute,
  AppAppointmentsViewingRoute: AppAppointmentsViewingRoute,
}

const AppAppointmentsRouteWithChildren = AppAppointmentsRoute._addFileChildren(
  AppAppointmentsRouteChildren,
)

interface AppPropertiesRouteChildren {
  AppPropertiesActiveRoute: typeof AppPropertiesActiveRoute
  AppPropertiesLeadsRoute: typeof AppPropertiesLeadsRoute
}

const AppPropertiesRouteChildren: AppPropertiesRouteChildren = {
  AppPropertiesActiveRoute: AppPropertiesActiveRoute,
  AppPropertiesLeadsRoute: AppPropertiesLeadsRoute,
}

const AppPropertiesRouteWithChildren = AppPropertiesRoute._addFileChildren(
  AppPropertiesRouteChildren,
)

interface AppRouteChildren {
  AppAnalyticsRoute: typeof AppAnalyticsRoute
  AppAppointmentsRoute: typeof AppAppointmentsRouteWithChildren
  AppBlogRoute: typeof AppBlogRoute
  AppClientsRoute: typeof AppClientsRoute
  AppCommunicationRoute: typeof AppCommunicationRoute
  AppDashboardRoute: typeof AppDashboardRoute
  AppDesignRoute: typeof AppDesignRoute
  AppDokumenteRoute: typeof AppDokumenteRoute
  AppEmailMarketingRoute: typeof AppEmailMarketingRoute
  AppHelpRoute: typeof AppHelpRoute
  AppInteressentenRoute: typeof AppInteressentenRoute
  AppKalenderRoute: typeof AppKalenderRoute
  AppMarketingRoute: typeof AppMarketingRoute
  AppMarketingAdminRoute: typeof AppMarketingAdminRoute
  AppMarketingUebersichtRoute: typeof AppMarketingUebersichtRoute
  AppMediathekRoute: typeof AppMediathekRoute
  AppOffersRoute: typeof AppOffersRoute
  AppPropertiesRoute: typeof AppPropertiesRouteWithChildren
  AppRadarRoute: typeof AppRadarRoute
  AppRechercheRoute: typeof AppRechercheRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppViewingConfirmationsRoute: typeof AppViewingConfirmationsRoute
  AppVoiceCallsRoute: typeof AppVoiceCallsRoute
  AppAdminAppointmentsOrphansRoute: typeof AppAdminAppointmentsOrphansRoute
  AppAdminAuditLogRoute: typeof AppAdminAuditLogRoute
  AppAdminJustimmoRoute: typeof AppAdminJustimmoRoute
  AppAdminSecurityRoute: typeof AppAdminSecurityRoute
  AppAdminSellerActivityRoute: typeof AppAdminSellerActivityRoute
  AppAdminStaffReportRoute: typeof AppAdminStaffReportRoute
  AppAdminTransfersRoute: typeof AppAdminTransfersRoute
  AppAdminZinshaeuserRoute: typeof AppAdminZinshaeuserRoute
  AppDokumenteChecklisteRoute: typeof AppDokumenteChecklisteRoute
  AppDokumenteKycRoute: typeof AppDokumenteKycRoute
  AppOffersIdRoute: typeof AppOffersIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAnalyticsRoute: AppAnalyticsRoute,
  AppAppointmentsRoute: AppAppointmentsRouteWithChildren,
  AppBlogRoute: AppBlogRoute,
  AppClientsRoute: AppClientsRoute,
  AppCommunicationRoute: AppCommunicationRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppDesignRoute: AppDesignRoute,
  AppDokumenteRoute: AppDokumenteRoute,
  AppEmailMarketingRoute: AppEmailMarketingRoute,
  AppHelpRoute: AppHelpRoute,
  AppInteressentenRoute: AppInteressentenRoute,
  AppKalenderRoute: AppKalenderRoute,
  AppMarketingRoute: AppMarketingRoute,
  AppMarketingAdminRoute: AppMarketingAdminRoute,
  AppMarketingUebersichtRoute: AppMarketingUebersichtRoute,
  AppMediathekRoute: AppMediathekRoute,
  AppOffersRoute: AppOffersRoute,
  AppPropertiesRoute: AppPropertiesRouteWithChildren,
  AppRadarRoute: AppRadarRoute,
  AppRechercheRoute: AppRechercheRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppViewingConfirmationsRoute: AppViewingConfirmationsRoute,
  AppVoiceCallsRoute: AppVoiceCallsRoute,
  AppAdminAppointmentsOrphansRoute: AppAdminAppointmentsOrphansRoute,
  AppAdminAuditLogRoute: AppAdminAuditLogRoute,
  AppAdminJustimmoRoute: AppAdminJustimmoRoute,
  AppAdminSecurityRoute: AppAdminSecurityRoute,
  AppAdminSellerActivityRoute: AppAdminSellerActivityRoute,
  AppAdminStaffReportRoute: AppAdminStaffReportRoute,
  AppAdminTransfersRoute: AppAdminTransfersRoute,
  AppAdminZinshaeuserRoute: AppAdminZinshaeuserRoute,
  AppDokumenteChecklisteRoute: AppDokumenteChecklisteRoute,
  AppDokumenteKycRoute: AppDokumenteKycRoute,
  AppOffersIdRoute: AppOffersIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  DatenschutzRoute: DatenschutzRoute,
  ImpressumRoute: ImpressumRoute,
  LoginRoute: LoginRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  ListingTokenRoute: ListingTokenRoute,
  SignTokenRoute: SignTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
